const colors = {
    '--smartpcmh-alt-lime-green': '#97c640',
    '--smartpcmh-green': '#329946'
};

export { colors };